enum RETURN_MODES {
  CARD = 'CARD',
  STORE_CREDIT = 'STORE_CREDIT',
}

export default RETURN_MODES
